import { render } from "./StaffManagement.vue?vue&type=template&id=71a5dee6&scoped=true"
import script from "./StaffManagement.vue?vue&type=script&lang=js"
export * from "./StaffManagement.vue?vue&type=script&lang=js"

import "./StaffManagement.vue?vue&type=style&index=0&id=71a5dee6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a5dee6"]])

export default __exports__